var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-accordion-item", on: { click: _vm.onClick } },
    [
      _c(
        "div",
        { staticClass: "ui-accordion-title" },
        [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
          _vm.$slots.title
            ? _c(
                "div",
                { staticClass: "ui-accordion-item__title-slot" },
                [_vm._t("title")],
                2
              )
            : _vm._e(),
          !_vm.notExtendable
            ? _c("chevron-animated", { attrs: { reverse: _vm.isOpen } })
            : _vm._e()
        ],
        1
      ),
      _vm.isOpen
        ? _c(
            "div",
            {
              class: ["ui-accordion-content", { opened: _vm.isOpen }],
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _vm.$slots.default
                ? _vm._t("default")
                : _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }